<template>
  <div id="booking-new" class="app-main-content" style="position:relative;">
    <booking-tree-grid
      v-if="!openMultiple"
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :context="context"
      :is-query="isQuery"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @split="splitHandle"
      @copy="copyHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="openMultiple"
      :view="view"
      @copy="copyHandle"
      @add="addHandle"
      @back="backToList"
      @synchronizeRowData="synchronizeRowData"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      v-show="copyDialog.visible"
      ref="jobCopyWindow"
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      :is-master="copyDialog.job.masterFlag || false"
      @confirmCallBack="confirmCallBackHandler"
    />

    <job-no-rule-selector
      v-show="jobNoRule.visible"
      ref="jobCopyWindow"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />
    <sea-im-container-type-dialog
      v-show="jobNewDialog.visible"
      ref="jobNewWindow"
      :visible.sync="jobNewDialog.visible"
      :rules="jobNewDialog.rules || []"
      :show-rule="jobNewDialog.showRule"
      @selectedBack="addHandlerSelect"
    />
  </div>
</template>

<script>
import { BookingNewContext } from './bookingNewContext'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import bookingTreeGrid from './components/SiBooking/bookingTreeGrid'
import bookingWorkspace from './components/SiBooking/bookingWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import SeaImContainerTypeDialog from '@/components/Cargo/Job/seaImContainerTypeDialog'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { doCopyJob, findSeaImportJobByNo, advancedQuery } from '@/api/SeaImport/seaImportJob'
import { queryJobNoRule } from '@/api/seaExport/seaExportJob'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import lodash from 'lodash'
import { DOC_PAGE_SOURCE, SENDING_1 } from '@/class/cargo/model/parameters/SystemConstants'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { JumpUtil } from '@/utils/JumpUtil'

export default {
  name: 'SiBooking',
  components: { SeaImContainerTypeDialog, bookingTreeGrid, bookingWorkspace, jobCopyWindow, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      openMultiple: Boolean(this.$route.query.openNew && this.$route.query.key), // （组件）打开了多个
      context: BookingNewContext.getInstance(),
      view: 'list',
      SENDING_1,
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      jobNewDialog: {
        visible: false,
        rules: '',
        showRule: false
      },
      isQuery: false // 根据路由参数进行高级查询
    }
  },
  computed: {
    office() {
      return this.context.office || this.$store.getters.currentOffice
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     // 如果此处需要用到生命周期created内初始化的数据，可能会导致报错
  //     if (to.query.jobNo) {
  //       vm.toDetail(vm, to.query.jobNo)
  //       location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
  //     }
  //   })
  // },
  activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      JumpUtil.jumpToTab(advancedQuery, {}, this.$route.params, this)
    } else if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.jobNo) {
      this.$refs.bookingWorkspace.activeTabName = this.$route.params.activeTabName || ''
      this.toDetail(this, this.$route.params.jobNo, this.$route.params.branchId)
      delete this.$route.params.jobNo
      delete this.$route.params.activeTabName
    } else if (this.$route.params.iType === SENDING_1.code) {
      const job = this.$route.params.job || {}
      this.toAddDetail(this, job)
    } else if (this.$route.params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.sopNodeAdvancedQuery()
    } else if (!this.openMultiple) {
      const saveJobNos = this.$route.params.saveJobNos
      const removedJobNos = this.$route.params.removedJobNos
      if (saveJobNos && removedJobNos) {
        delete this.$route.params.saveJobNos
        delete this.$route.params.removedJobNos
        if (this.view === 'list') {
          this.backToList(saveJobNos, removedJobNos)
        }
      }
    }
  },
  async created() {
    await this.context.prepareData()
  },
  async mounted() {
    if (this.openMultiple) {
      this.view = 'detail'
      let rowData = this.$route.params.rowData
      if (!rowData || rowData.length === 0) {
        const loading = getLoading4Cxt(this)
        try {
          const res = await findSeaImportJobByNo({ jobNo: this.$route.query.key, branchId: this.$store.getters.currentOfficeId })
          if (res.data.list.length === 0) {
            this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
            return
          }
          rowData = res.data.list
        } catch (err) {
          this.$message.error(this.$t('Message.JumpFailed'))
          throw err
        } finally {
          loading.close()
        }
      }
      rowData = this.getNewDetailData(rowData)
      const selectedRow = rowData.find(p => p.jobNo === this.$route.query.key)
      if (selectedRow) {
        let action = 'look'
        if (this.$route.params.action) {
          action = this.$route.params.action
          delete this.$route.params.action
        }
        if (this.$route.params.activeTabName) {
          this.$refs.bookingWorkspace.activeTabName = this.$route.params.activeTabName
          delete this.$route.params.activeTabName
        }
        this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
      }
    } else if (this.$route.params.code) {
      this.isQuery = true
      this.view = 'list'
      this.sopNodeAdvancedQuery()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        },
        { fieldType: 'FIELD_CHECKBOX', fieldName: 'loadRelationJobs', operator: '=', value: false }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo, branchId) {
      const params = {}
      params.branchId = branchId || vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      params.jump = true
      vm.view = 'detail'
      const loading = getLoading4Cxt(this)
      findSeaImportJobByNo(params).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(vm.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      }).finally(() => {
        loading.close()
      })
    },
    /**
     * 打开新增页面
     * @param job
     */
    async toAddDetail(vm, job) {
      if (!this.config) {
        await this.context.prepareData()
      }
      const _job = new SeaImportJob().fillDefaultValue().getData()
      Object.assign(_job, job)
      _job.jobNoRule = ''
      _job.masterFlag = _job.containerLoadType === 'CON'
      _job.lob = 'SI'
      // bookingWorkspace onShow 已实现 this.loadEntityDefaultValues()
      // 新增集拼，默认显示MBL页签
      if (_job.masterFlag) {
        _job.signHBL = false
        _job.mblOnly = true
      } else {
        _job.signHBL = true
        _job.mblOnly = false
        // CARGO-46370 OCR海进提单识别收发通未自动带入到提单界面
        let hdoc = await new SeaImportJob(_job).getCargoDocByType(CargoDocConsts.HBL, false)
        if (!hdoc) {
          hdoc = await SeaCargoDoc.createCargoDoc(_job, CargoDocConsts.HBL)
          // 发货人
          hdoc.shipperLine1 = _job.shipperLine1
          hdoc.shipperLine2 = _job.shipperLine2
          hdoc.shipperLine3 = _job.shipperLine3
          hdoc.shipperLine4 = _job.shipperLine4
          hdoc.shipperLine5 = _job.shipperLine5
          hdoc.shipperLine6 = _job.shipperLine6
          hdoc.shipperLine7 = _job.shipperLine7
          // 收货人
          hdoc.consigneeLine1 = _job.consigneeLine1
          hdoc.consigneeLine2 = _job.consigneeLine2
          hdoc.consigneeLine3 = _job.consigneeLine3
          hdoc.consigneeLine4 = _job.consigneeLine4
          hdoc.consigneeLine5 = _job.consigneeLine5
          hdoc.consigneeLine6 = _job.consigneeLine6
          hdoc.consigneeLine7 = _job.consigneeLine7
          // 通知人
          hdoc.notifyLine1 = _job.notifyLine1
          hdoc.notifyLine2 = _job.notifyLine2
          hdoc.notifyLine3 = _job.notifyLine3
          hdoc.notifyLine4 = _job.notifyLine4
          hdoc.notifyLine5 = _job.notifyLine5
          hdoc.notifyLine6 = _job.notifyLine6
          hdoc.notifyLine7 = _job.notifyLine7
          hdoc.pageSource = DOC_PAGE_SOURCE
          hdoc.insideQuantity = _job.insideQuantity
          hdoc.signDateBL = _job.signDateBL
          hdoc.paymentPlaceBL = _job.paymentPlaceBL
          hdoc.releaseType = _job.orderType
          hdoc.signPlaceBL = _job.signPlaceBL
          if (!_job.seaCargoDoc) {
            _job.seaCargoDoc = []
          }
          _job.seaCargoDoc.push(hdoc)
        }
        let mDoc = await new SeaImportJob(_job).getCargoDocByType(CargoDocConsts.MBL, false)
        if (!mDoc) {
          mDoc = await SeaCargoDoc.newCargoDoc(_job, CargoDocConsts.MBL)
          // 发货人
          mDoc.shipperLine1 = _job.shipperLine1
          mDoc.shipperLine2 = _job.shipperLine2
          mDoc.shipperLine3 = _job.shipperLine3
          mDoc.shipperLine4 = _job.shipperLine4
          mDoc.shipperLine5 = _job.shipperLine5
          mDoc.shipperLine6 = _job.shipperLine6
          mDoc.shipperLine7 = _job.shipperLine7
          // 收货人
          mDoc.consigneeLine1 = _job.consigneeLine1
          mDoc.consigneeLine2 = _job.consigneeLine2
          mDoc.consigneeLine3 = _job.consigneeLine3
          mDoc.consigneeLine4 = _job.consigneeLine4
          mDoc.consigneeLine5 = _job.consigneeLine5
          mDoc.consigneeLine6 = _job.consigneeLine6
          mDoc.consigneeLine7 = _job.consigneeLine7
          // 通知人
          mDoc.notifyLine1 = _job.notifyLine1
          mDoc.notifyLine2 = _job.notifyLine2
          mDoc.notifyLine3 = _job.notifyLine3
          mDoc.notifyLine4 = _job.notifyLine4
          mDoc.notifyLine5 = _job.notifyLine5
          mDoc.notifyLine6 = _job.notifyLine6
          mDoc.notifyLine7 = _job.notifyLine7
          mDoc.pageSource = DOC_PAGE_SOURCE
          mDoc.insideQuantity = _job.insideQuantity
          mDoc.signDateBL = _job.signDateBL
          mDoc.paymentPlaceBL = _job.paymentPlaceBL
          mDoc.blNumber = _job.blNumber
          mDoc.releaseType = _job.orderType
          mDoc.signPlaceBL = _job.signPlaceBL
          if (!_job.seaCargoDoc) {
            _job.seaCargoDoc = []
          }
          _job.seaCargoDoc.push(mDoc)
        }
      }
      _job.csr = this.$store.getters.userId
      // h5 不需要updatePageJobData(_job,true,false);

      console.log('=====_job', _job)
      this.detailHandle('add', _job)
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    async addHandle() {
      if (JobUtils.checkHQ()) { return }
      this.loading = getLoading()
      this.jobNewDialog.showRule = String(this.context.config.get('UseNewJobNoRule')) === '1'
      queryJobNoRule(SystemConstants.SI.code).then(res => {
        const rules = res.data
        if (rules && rules.length > 1) {
          this.jobNewDialog.rules = rules
        }
        this.jobNewDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 新增job 选择类型完成以后得事件
    async addHandlerSelect(data) {
      const _job = new SeaImportJob().fillDefaultValue().getData()

      //  callFun
      _job.jobNoRule = data['jobNoRule']
      _job.containerLoadType = data.cargoType
      _job.masterFlag = _job.containerLoadType === 'CON'
      _job.lob = 'SI'
      // bookingWorkspace onShow 已实现 this.loadEntityDefaultValues()
      // 新增集拼，默认显示MBL页签
      if (_job.masterFlag) {
        _job.signHBL = false
        _job.mblOnly = true
      } else {
        _job.signHBL = true
        _job.mblOnly = false
      }
      _job.csr = this.$store.getters.userId
      // h5 不需要updatePageJobData(_job,true,false);

      console.log('=====_job', _job)
      this.detailHandle('add', _job)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    backToList(saveJobNos, removedJobNos) {
      if (this.openMultiple) {
        this.$router.push({ name: 'SiBooking', params: { saveJobNos, removedJobNos }})
        return
      }
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
      }
      if (this.view === 'detail') {
        this.$refs.bookingTreeGrid.$el.style.display = 'flex'
        this.$refs.bookingWorkspace.$el.style.display = 'none'
      }
      this.view = 'list'
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(saveJobNos, removedJobNos)
      }
    },
    copyHandle(row) {
      // 以后按本次选择复制，不弹出此框
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob + (row.masterFlag ? '_MASTER' : '')) // 是否显示复制选项弹框【勾选是true不显示】
      this.$logger.log('是否显示复制选项弹框', typeof isShowView + isShowView)
      if (isShowView !== true) {
        this.copyDialog.visible = true
      } else {
        this.confirmCallBackHandler()
      }
    },
    async confirmCallBackHandler() {
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        const loading = getLoading4Cxt(this)
        queryJobNoRule(SystemConstants.SI.code).then(res => {
          this.ruleResultHandler(res)
        }).finally(() => {
          loading.close()
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(jobNoRule) {
      this.loading = getLoading()
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.copyDialog.job.lob
      let notMatchAgainSelect = false
      if (this.copyDialog.job.masterFlag) {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER')
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob + '_MASTER')
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob + '_MASTER')
      } else {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      }
      item.masterFlag = this.copyDialog.job.masterFlag
      doCopyJob(item).then(async res => {
        const newJob = res.data
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'SiBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect)
        this.$logger.log('复制-new job', res.data)
        this.detailHandle('copy', newJob)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        rowData = this.$refs.bookingTreeGrid.gridOptions.api.getModel().rowsToDisplay.map(node => node.data).filter(data => data && Object.keys(data).length > 0)
        rowData = this.getNewDetailData(rowData)
        this.view = 'detail'
      }
      if (row.uuid) {
        row = rowData.find(p => p.uuid === row.uuid)
      } else {
        new SeaImportJob(row).fillDefaultValue() // 数据补充完整
        row.version = 0 // 版本号置为0，重新加载job
        row = { ...row } // 需重新构造对象，以便新增加的属性可以被vue监听到
      }

      if (this.$refs.bookingWorkspace) {
        this.$refs.bookingWorkspace.saveJobNos = []
        this.$refs.bookingWorkspace.removedJobNos = []
        this.$refs.bookingWorkspace.onShow(type, rowData, row)
      } else {
        this.$nextTick(() => {
          this.$refs.bookingWorkspace.saveJobNos = []
          this.$refs.bookingWorkspace.removedJobNos = []
          this.$refs.bookingWorkspace.onShow(type, rowData, row)
        })
      }
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new SeaImportJob(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    },
    synchronizeRowData(rowData) {
      if (this.$refs.bookingTreeGrid) this.$refs.bookingTreeGrid.rowData = rowData
    }
  }
}
</script>

<style lang="scss">
</style>
